import { createContext, useContext } from "react";

/**
 * The player context object, on its own with no component imports.
 *
 * PlayerProvider renders VideoModal and GlobalVideoPlayer, and both of those need
 * usePlayer back. Keeping the context in a leaf module is what stops that from
 * being a cycle - the same trap that already forced PlayerContext out of the
 * contexts barrel.
 */
export const PlayerContext = createContext(null);

export const usePlayer = () => useContext(PlayerContext);
